// Single source of truth for contact info
export const BRAND = "Quick Fix";
export const PHONE_RAW = "+919632964006"; // E.164 format
export const PHONE_DISPLAY = "+91 96329 64006";
export const WHATSAPP_RAW = "919632964006";
export const WHATSAPP_MSG = encodeURIComponent(
  "Hi Quick Fix, I am looking for AC repair service in bangalore"
);
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_RAW}?text=${WHATSAPP_MSG}`;
export const TEL_LINK = `tel:${PHONE_RAW}`;

// Fires Google Ads "Lead" conversion. Safe to call from any click handler;
// does NOT intercept navigation (the href/target on the link continues to work).
export const trackLeadConversion = () => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag_report_conversion === "function") {
      window.gtag_report_conversion();
    }
  } catch (e) {
    // swallow — never block the user from calling/WhatsApping
  }
};
